import type React from "react";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

interface FileResultRendererMDProps {
  result: string;
}

const mdParser = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
});

export const FileResultRendererMD: React.FC<FileResultRendererMDProps> = ({
  result,
}) => {
  const processHtmlWithLiteralBullets = (): string => {
    const rawHtml = mdParser.render(result);

    const parser = new DOMParser();
    const document = parser.parseFromString(rawHtml, "text/html");

    const topLevelUls = Array.from(
      document.body.querySelectorAll(":scope > ul")
    );
    const topLevelOls = Array.from(
      document.body.querySelectorAll(":scope > ol")
    );

    topLevelUls.forEach((ul) => {
      ul.querySelectorAll(":scope > li").forEach((li) => {
        li.innerHTML = `• ${li.innerHTML}`;
      });
    });

    topLevelOls.forEach((ol) => {
      ol.querySelectorAll(":scope > li").forEach((li, index) => {
        const firstP = li.querySelector("p");
        if (firstP) {
          firstP.innerHTML = `${index + 1}. ${firstP.innerHTML}`;
        } else {
          li.innerHTML = `${index + 1}. ${li.innerHTML}`;
        }
      });
    });

    [...document.body.querySelectorAll(":scope > ul, :scope > ol")].forEach(
      (list) => {
        const nextElement = list.nextElementSibling;
        if (
          nextElement &&
          nextElement.tagName === "P" &&
          !(
            nextElement.childElementCount === 1 &&
            nextElement.firstElementChild?.tagName === "STRONG"
          )
        ) {
          const br = document.createElement("br");
          list.insertAdjacentElement("afterend", br);
        }
      }
    );

    return DOMPurify.sanitize(document.body.innerHTML);
  };

  return (
    <div
      dangerouslySetInnerHTML={{ __html: processHtmlWithLiteralBullets() }}
      className="editor-markdown editor-markdown__viewer"
    />
  );
};
